import { getBootstrapConfig } from './wp-session';

export const appEnv = getBootstrapConfig();
